module.exports = __webpack_public_path__ + "static/media/yuntaishan1.8569fa66.webp";